/*
 * @Author: cc
 * @Date: 2021-04-23 17:44:50
 * @LastEditTime: 2021-04-29 18:47:02
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\directive\personReceiveBtns\personReceiveBtns.js
 * @Description: 个人稿库、已收稿库顶部按钮 
 * @Special: 这里是继承了父控制器的作用域，可以访问但不能篡改。里面的主要信息，都是根据父控制器的status字段获取，如：rigths（权限）、trench（个人稿库、已收稿库、部门稿库等）
 */
angular.module('iWoPreviewModule').directive('iwoPersonReceiveBtns', ['$state', '$window', 'editIsLock', 'myManuscriptService', 'newMediaService', 'editFusionEditorService', 'messagePublishService', 'iWoService', 'storageListenerService', 'editingCenterService',
    function ($state, $window, editIsLock, myManuscriptService, newMediaService, editFusionEditorService, messagePublishService, iWoService, storageListenerService, editingCenterService) {
        return {
            scope: true,
            restrict: 'EA',
            templateUrl: './editingCenter/iWo/iWoPreview/directive/personReceiveBtns/index.html',
            link: function ($scope) {
                initParams();

                /**
                 * [initParams description] 初始化参数
                 * @return  {[type]}  [return description]
                 */
                function initParams() {
                    $scope.btnOperateParams = {
                        submit: {
                            personal: 'PersonalSubmitDoc',
                            received: 'ReceivedSubmitDoc'
                        }, // 提交参数
                        waste: {
                            personal: {
                                serviceid: 'mlf_fusionmyrelease',
                                methodname: 'scrapMyRelease',
                            },
                            received: {
                                serviceid: 'mlf_fusionmyrelease',
                                methodname: 'scrapReceivedRelease',
                            }
                        }, // 废稿参数
                        transmit: {
                            basicParams: [{
                                CHNLDOCID: $state.params.iwochnldocid,
                                METADATAID: $state.params.iwometadataid
                            }],
                            personal: 'personalTransferMetaDatas',
                            received: 'receivedTransferMetaDatas'
                        } // 传稿参数
                    };
                    $scope.data.trench = $scope.status.trench;
                }

                /**
                 * [edit description]跳转到编辑
                 * @return {[type]} [description]null
                 */
                $scope.edit = function () {
                    editingCenterService.isListDocCanOper($state.params.iwochnldocid, refreshPage()).then(() => {
                        edit();
                    });
                };

                /**
                 * [submit description] 提交
                 * @return  {[type]}  [return description]
                 */
                $scope.submit = function () {
                    editingCenterService.isListDocCanOper($state.params.iwochnldocid, refreshPage()).then(() => {
                        $scope.submitList = [{
                            CHNLDOCID: $state.params.iwochnldocid,
                            METADATAID: $state.params.iwometadataid,
                            DOCTYPEID: $scope.list.DOCTYPEID,
                        }];
                        newMediaService.iwoSubmit($scope, $scope.btnOperateParams.submit[$scope.status.trench]);
                    });
                };

                /**
                 * [departmentSubmit description] 部门提交
                 * @return  {[type]}  [return description]
                 */
                $scope.departmentSubmit = function () {
                    editingCenterService.isListDocCanOper($state.params.iwochnldocid, refreshPage()).then(() => {
                        editFusionEditorService.departmentSubmit($scope, $scope.list.TITLE);
                    });
                };

                /**
                 * [share description] 共享按钮
                 * @return  {[type]}   [return description]
                 */
                $scope.share = function () {
                    editingCenterService.isListDocCanOper($state.params.iwochnldocid, refreshPage()).then(() => {
                        newMediaService.iwoShare($scope).then(function (shareObj) {
                            messagePublishService.publish('doEditPageOperation', iWoService.packageShareParams(shareObj));
                        });
                    });
                };

                /**
                 * [sendMessage description] 发送按钮
                 * @return  {[type]}  [return description]
                 */
                $scope.sendMessage = function () {
                    editFusionEditorService.sendmessage($scope);
                };

                /**
                 * [wasteDraft description] 废稿
                 * @return  {[type]}  [return description]
                 */
                $scope.wasteDraft = function () {
                    editingCenterService.isListDocCanOper($state.params.iwochnldocid, refreshPage()).then(() => {
                        let params = $scope.btnOperateParams.waste[$scope.status.trench];
                        params = angular.extend(params, {
                            ChnlDocIds: $state.params.iwochnldocid,
                            MetaDataIds: $state.params.iwometadataid
                        });
                        $scope.data.trench = 'Iwo';
                        newMediaService.delete($scope, params);
                    });
                };

                /**
                 * [transmitDraft description] 传稿
                 * @return  {[type]}  [return description]
                 */
                $scope.transmitDraft = function () {
                    editingCenterService.isListDocCanOper($state.params.iwochnldocid, refreshPage()).then(() => {
                        myManuscriptService.draft('传稿', $scope.btnOperateParams.transmit.basicParams, () => {
                            storageListenerService.addListenerToIwo('newsPassed');
                            $window.close();
                            // let opened = $window.open('about:blank', '_self');
                            // opened.close();
                        }, () => {
                            // 
                        }, $scope.btnOperateParams.transmit[$scope.status.trench]);
                    });
                };

                /**
                 * [edit description] 编辑页逻辑
                 * @return  {[type]}  [return description]
                 */
                function edit() {
                    if ($scope.status.isDeptartment) {
                        editIsLock.isLock($scope.data.item, -1).then((data) => {
                            if (data.ISLOCK === 'false') {
                                routerToEditPage();
                            } else {
                                editIsLock.checkUnlockPermissions($scope.data.item, data).then(function () {
                                    routerToEditPage();
                                });
                            }
                        });
                    } else {
                        routerToEditPage();
                    }
                }

                /**
                 * [routerToEditPage description] 跳转到编辑页
                 * @return  {[type]}  [return description]
                 */
                function routerToEditPage() {
                    myManuscriptService.fusionRouter($scope.data.item, $scope);
                    window.close();
                }

                /**
                 * [refreshPage 当稿件已不在当前用户稿库时，刷新页面，重新获取按钮权限]
                 *
                 * @return  {[type]}  [return description]
                 */
                function refreshPage() {
                    $state.reload($state.current);
                }
            }
        };
    }]);
